export const navLinks = [
  { label: "时间线", href: "#timeline" },
  { label: "全记录", href: "#archive" },
  { label: "课代表", href: "#digest" },
  { label: "下载", href: "#download" },
  { label: "问答", href: "#faq" },
];

export const heroSideCards = [
  {
    id: "today",
    tone: "primary",
    icon: "ri-flashlight-line",
    label: "今日更新",
    title: "综艺剪辑争议 · 时间线已补录",
    meta: "09-10 09:20 更新",
    kind: "text",
  },
  {
    id: "coverage",
    tone: "accent",
    icon: "ri-pie-chart-line",
    label: "覆盖率",
    title: "近 12 个月热点",
    meta: "92%",
    kind: "progress",
    percent: 92,
  },
  {
    id: "digest",
    tone: "secondary",
    icon: "ri-file-list-3-line",
    label: "课代表小结",
    title: "3 分钟看懂前因后果",
    meta: "6 个关键节点",
    kind: "text",
  },
  {
    id: "download",
    tone: "primary",
    icon: "ri-download-2-line",
    label: "下载入口",
    title: "全记录完整版",
    meta: "PDF · 12.4 MB",
    kind: "action",
  },
];

export const statsData = [
  { value: "1,286", label: "已归档事件", unit: "起" },
  { value: "17,904", label: "时间线节点", unit: "条" },
  { value: "2019–2026", label: "覆盖区间", unit: "年" },
  { value: "每日", label: "更新频率", unit: "次" },
];

export const guideSteps = [
  {
    no: "01",
    icon: "ri-history-line",
    title: "从起点开始读",
    desc: "时间线按发生先后排列，最早的一条即「起点」，顺着往下读即可还原完整脉络。",
  },
  {
    no: "02",
    icon: "ri-filter-3-line",
    title: "按阶段筛选",
    desc: "用「起点 / 发酵 / 爆发 / 后续」四段筛选，快速跳到你想看的那一段节点。",
  },
  {
    no: "03",
    icon: "ri-download-2-line",
    title: "下载完整版留档",
    desc: "把全记录、长图与节点速查表一次导出，离线也能随时回看前因后果。",
  },
];

export const timelineFilters = ["全部", "起点", "发酵", "爆发", "后续"];

export const timelineData = [
  {
    id: "t1",
    phase: "起点",
    date: "03-08",
    time: "21:40",
    title: "一条日常动态被截图转发",
    desc: "当事人发布的一条普通日常内容在社群被截图搬运，评论区出现不同解读，事件正式进入大众视野。",
    tags: ["起点", "动态截图"],
    verified: true,
  },
  {
    id: "t2",
    phase: "起点",
    date: "03-09",
    time: "10:15",
    title: "原始出处被完整扒出",
    desc: "课代表补全了截图的时间、来源与上下文，第一版「超碰吃瓜」时间线雏形在讨论帖中出现。",
    tags: ["上下文", "溯源"],
    verified: true,
  },
  {
    id: "t3",
    phase: "发酵",
    date: "03-11",
    time: "13:02",
    title: "话题词条冲上热搜榜",
    desc: "相关词条在两小时内快速攀升，各方账号开始陆续发声，信息量陡增，节点从个位数涨到二十余条。",
    tags: ["热搜", "扩散"],
    verified: true,
  },
  {
    id: "t4",
    phase: "发酵",
    date: "03-12",
    time: "19:48",
    title: "多方口径出现明显分歧",
    desc: "不同信源对同一时间点的描述并不一致，时间线整理开始区分「已核实」与「存疑」两类节点。",
    tags: ["信源", "存疑"],
    verified: false,
  },
  {
    id: "t5",
    phase: "爆发",
    date: "03-14",
    time: "22:30",
    title: "关键素材在同一时段集中释出",
    desc: "多条此前未公开的素材在相近时间出现，事件达到讨论峰值，单日新增节点超过四十条。",
    tags: ["峰值", "物证"],
    verified: true,
  },
  {
    id: "t6",
    phase: "爆发",
    date: "03-15",
    time: "16:20",
    title: "当事方首度正式回应",
    desc: "当事方发布声明，对时间线中的部分节点作出确认或澄清，课代表据此更新了完整版全记录。",
    tags: ["回应", "更新"],
    verified: true,
  },
  {
    id: "t7",
    phase: "后续",
    date: "03-20",
    time: "11:05",
    title: "热度回落，进入长期归档",
    desc: "讨论热度逐步回落，时间线转入长期维护，后续只补充具有实质进展的节点。",
    tags: ["回落", "归档"],
    verified: true,
  },
  {
    id: "t8",
    phase: "后续",
    date: "04-02",
    time: "09:00",
    title: "完整版全记录定稿发布",
    desc: "经多轮核对后，超碰吃瓜完整版时间线定稿，来龙去脉与前因后果可在一个页面内完整回看。",
    tags: ["定稿", "完整版"],
    verified: true,
  },
];

export const archiveData = [
  {
    id: "a1",
    step: "起点",
    img: "https://readdy.ai/api/search-image?query=Minimal%20editorial%20flat%20lay%20of%20a%20single%20watermelon%20slice%20and%20a%20small%20opened%20notebook%20with%20a%20pen%20on%20a%20warm%20cream%20paper%20background%2C%20soft%20diffused%20daylight%2C%20muted%20amber%20tones%2C%20generous%20negative%20space%2C%20clean%20minimal%20composition%2C%20high%20detail%20photography&width=1200&height=900&seq=gcg-arch-start-01&orientation=landscape",
    title: "起点档案：一条动态如何被看见",
    desc: "完整保留了最初的截图、发布时间与原始社群，标注了它为什么会被注意，以及第一批讨论的走向。",
    tags: ["原始截图", "发布时间", "上下文"],
  },
  {
    id: "a2",
    step: "发酵",
    img: "https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20of%20several%20watermelon%20slices%20spreading%20outward%20across%20a%20warm%20cream%20desk%20with%20scattered%20sticky%20notes%20and%20index%20cards%2C%20soft%20daylight%2C%20muted%20amber%20and%20teal%20accents%2C%20clean%20minimal%20background%2C%20high%20detail%20photography&width=1200&height=900&seq=gcg-arch-rise-01&orientation=landscape",
    title: "发酵档案：分歧是怎么出现的",
    desc: "同一时间点往往有多个版本，这一册把每条说法的出处并列摆放，让「已核实」和「存疑」一眼可分辨。",
    tags: ["多方口径", "信源对照", "存疑标注"],
  },
  {
    id: "a3",
    step: "爆发",
    img: "https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20of%20many%20watermelon%20slices%20arranged%20in%20a%20dense%20burst%20on%20a%20warm%20cream%20surface%20with%20a%20folded%20newspaper%20and%20a%20highlight%20marker%2C%20soft%20daylight%2C%20strong%20amber%20accents%2C%20clean%20minimal%20background%2C%20high%20detail%20photography&width=1200&height=900&seq=gcg-arch-peak-01&orientation=landscape",
    title: "爆发档案：峰值那一刻的完整节点",
    desc: "讨论峰值当日的节点最密集，这一册按时、分、秒还原素材出现的先后顺序，避免把巧合当成因果。",
    tags: ["时间精确", "节点密集", "峰值当日"],
  },
  {
    id: "a4",
    step: "后续",
    img: "https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20of%20neatly%20stacked%20archive%20folders%20and%20a%20closed%20document%20box%20beside%20a%20watermelon%20slice%20on%20a%20warm%20cream%20background%2C%20soft%20daylight%2C%20muted%20amber%20tones%2C%20quiet%20minimal%20composition%2C%20high%20detail%20photography&width=1200&height=900&seq=gcg-arch-close-01&orientation=landscape",
    title: "后续档案：热度之后还剩什么",
    desc: "热度会退，记录不会。这一册只收录有实质进展的节点，把长期维护的部分和当时的情绪区分开来。",
    tags: ["长期维护", "实质进展", "定稿"],
  },
];

export const digestData = [
  { no: "01", title: "起点其实很小", desc: "最初只是一条被截图转发的日常动态，本身信息量有限。" },
  { no: "02", title: "溯源补全上下文", desc: "补上时间、来源与上下文后，第一版时间线雏形才出现。" },
  { no: "03", title: "发酵伴随分歧", desc: "多方口径不一致，节点开始区分「已核实」与「存疑」。" },
  { no: "04", title: "爆发在集中释出", desc: "关键素材在同一时段集中出现，讨论到达峰值。" },
  { no: "05", title: "回落后进入归档", desc: "热度回落，时间线转入长期维护，只在有进展时补录。" },
];

export const downloadData = [
  {
    id: "pdf",
    icon: "ri-file-pdf-2-line",
    title: "全记录完整版",
    desc: "含全部节点与信源标注",
    format: "PDF",
    size: "12.4 MB",
    tone: "primary",
  },
  {
    id: "longimg",
    icon: "ri-image-2-line",
    title: "时间线长图",
    desc: "一图看完全部脉络",
    format: "4K PNG",
    size: "8.2 MB",
    tone: "accent",
  },
  {
    id: "sheet",
    icon: "ri-table-line",
    title: "节点速查表",
    desc: "按阶段与日期排序",
    format: "CSV",
    size: "1.1 MB",
    tone: "secondary",
  },
  {
    id: "card",
    icon: "ri-sticky-note-line",
    title: "课代表卡片",
    desc: "要点小结可分享版",
    format: "PNG",
    size: "2.6 MB",
    tone: "primary",
  },
];

export const faqData = [
  {
    q: "超碰吃瓜时间线是什么？",
    a: "它是一份按时间先后整理的事件档案页，把零散的信息重新排成一条完整的「来龙去脉」，方便你从一个页面看清前因后果。",
  },
  {
    q: "「完整版全记录」和普通整理有什么区别？",
    a: "完整版保留了每个节点的原始时间、信源与上下文标注，并按阶段分区；普通整理通常只有结论摘要。",
  },
  {
    q: "时间线多久更新一次？",
    a: "热点事件在讨论期通常每日更新，事件热度回落后转入长期维护，只在有实质进展时补充新节点。",
  },
  {
    q: "看不懂该从哪一条开始？",
    a: "建议直接从时间线最早的一条读起，或先看「课代表梳理」里的要点小结，再去对照具体节点。",
  },
  {
    q: "可以下载下来离线看吗？",
    a: "页面提供 PDF 完整版、时间线长图与节点速查表三种格式，点击下载入口即可导出留档。",
  },
];